import { useSPTableWithModelSchema } from './useSPTableWithModelSchema';
export const GetFilterTableSchema = ({ config, schemaTree, metaConfig, values, rulesMap }: any) => {
  let schemaList: any[] = [];
  const mainModule = metaConfig?.freeComponentsConfig['position-module'];
  const getSchemaList = (arr: any[], code: string) => {
    arr?.forEach((el: any) => {
      if (el.code === mainModule) {
        schemaList = el.children;
        return;
      }
      if (el.children && el.children?.length > 0) {
        getSchemaList(el.children, code);
      }
    });
  };
  getSchemaList(schemaTree, mainModule);
  const { spRecordListSchema } = useSPTableWithModelSchema({ schemaList, metaConfig, values, rulesMap });
  const moduleList: string[] = [];
  config?.dataMeta?.forEach((item: any) => {
    moduleList.push(item.filterModule);
  });
  const filterData = spRecordListSchema?.filter((mo: any) => moduleList.includes(mo.handle)) || [];
  const filterTableSchema = filterData?.map((el: any) => {
    const filterProps = config?.dataMeta?.find((item: any) => item.filterModule === el.handle);
    return {
      ...el,
      filterProps,
    };
  });
  return {
    filterTableSchema,
  };
};

export default GetFilterTableSchema;
